module.exports = __webpack_public_path__ + "static/0.696189cb543b6e670f277650a976030c.mp3";